import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/fontawesome-free-solid';

class CheckboxLayer extends Component {
    render() {
        const {checked, onClick} = this.props;

        return (
            <div id="checkboxLayer">
                <div className="checkbox-wrapper" onClick={onClick}>
                    <input type="checkbox" checked={checked}/>
                    <div className="sign">
                        <span className="checked">
                            <FontAwesomeIcon icon={faCheck} />
                        </span>
                        <span className="unchecked">
                            <FontAwesomeIcon icon={faMinus} />
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

const CheckboxLayerWithRedux = connect()(CheckboxLayer);

export {CheckboxLayerWithRedux as CheckboxLayer};


// WEBPACK FOOTER //
// ./src/components/EventPage/images/CheckboxLayer.jsx